export * from './Clipboard';
export * from './Easing';
export * from './Image';
export * from './Line';
export * from './Score';
export * from './Time';
export * from './QR';
export function generateCode(length: number): string {
  const patterns: string = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code: string = '';

  for (let i = 0; i < length; i++) {
    code += patterns[Math.floor(Math.random() * patterns.length)];
  }

  return code;
}
